// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__3IT0A","card":"About_card__10_QC"};